
// const baseUrl = 'https://51it865526.zicp.fun/knowledge'
const baseUrl = 'https://wqcheng.com/knowledge' //'http://192.168.0.96:9090/knowedge' // 'https://wqcheng.com/knowledge'
import { Loading } from 'element-ui';
export default // 创建一个 fetch 的封装函数  
    function customFetch(url, options = {}) {
    // 设置默认的请求选项  
    const defaultOptions = {
        method: 'POST', // 默认使用 GET 请求  
        headers: {
            'Content-Type': 'application/json', // 默认设置内容类型为 JSON  
        },
    };
    console.log(options)
    // 合并默认选项和传入的选项  
    const mergedOptions = { ...defaultOptions, ...options };
    const requestUrl = baseUrl + url
    const loading = Loading.service(options);({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    // 发送请求  
    return fetch(requestUrl, mergedOptions)
        .then(response => {
            loading.close();
            // 检查响应状态码是否在 200-299 之间  
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            console.log(response)
            return response;
        })
        .then(response => response.json()) // 解析 JSON 数据  
        .catch(error => {
            loading.close();
            // 这里可以进一步处理错误，例如显示错误消息或进行重试  
            console.error('There was a problem with your fetch operation:', error);
            throw error;
        });
}  